import { createContext, useContext } from 'react'

export type ListDialogOptions = {
  title: string
  items: string[]
}

export type ListDialogContextType = {
  show: (options: ListDialogOptions) => void
}

// This is a workaround because notistack snackbar actions use portals
export const useListDialogStore: { show?: (options: ListDialogOptions) => void } = {}

export const ListDialogContext = createContext<ListDialogContextType | null>(null)

export const useListDialog = () => {
  const context = useContext(ListDialogContext)
  if (!context) {
    throw new Error('useListDialog must be used within a ListDialogProvider')
  }
  return context
}
